import { mapLegalEntitySummary } from '@webapp/core/data-access/mappers/mapLegalEntitySummary'
import { type AddressConstructor } from '@webapp/core/value-objects/Address'
import { type PrimaryCategoryConfigConstructor } from '@webapp/platform/organization-management/entities/PrimaryCategoryConfig'
import {
  type AddressApiModel,
  type PrimaryCategoryConfigApiModel,
} from '../api-models/PrimaryCategoryConfigApiModel'

const mapAddressApiModel = (apiModel: AddressApiModel): AddressConstructor => ({
  name: apiModel.name,
  addressLineOne: apiModel.addressLineOne,
  city: apiModel.city,
  stateProvince: apiModel.state_province,
  postalCode: apiModel.postalCode,
  country: apiModel.country,
})

export const mapPrimaryCategoryConfigApiModel = (
  apiModel: PrimaryCategoryConfigApiModel
): PrimaryCategoryConfigConstructor => ({
  id: apiModel.id,
  name: apiModel.name,
  email: apiModel.email,
  phoneOne: apiModel.phoneOne,
  active: apiModel.active,
  headquarter: apiModel.headquarter,
  editable: apiModel.editable,
  logo: apiModel.logo,
  billingAddress: mapAddressApiModel(apiModel.primary_billing_address),
  ...(apiModel.legal_entity
    ? { legalEntity: mapLegalEntitySummary(apiModel.legal_entity) }
    : {}),
})
